import create from 'utilities/zustand/create';

export const usePovStore = create(set => ({
  pov: null,

  setPov: pov => {
    set({ pov: pov });
  },
}));
